import { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
import { track } from "../lib/posthog";

const NavigationContext = createContext(null);

export function NavigationProvider({ children }) {
  const currentMonth = new Date().getMonth();

  const [activeMonth, setActiveMonth] = useState(currentMonth);
  const [view, setView] = useState("mes");
  const [section, setSection] = useState("resumen");
  const [periodFilter, setPeriodFilter] = useState("mes"); // "semana" | "cobro" | "mes"
  const [showMonthPicker, setShowMonthPicker] = useState(false);

  // Trackear cambios de vista/sección. Skip el primer render para no contar el mount inicial.
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    try { track("view_changed", { view, section }); } catch {}
  }, [view, section]);

  const navigateTo = useCallback((v, sec, month) => {
    if (v !== undefined) setView(v);
    if (sec !== undefined) setSection(sec);
    if (month !== undefined) setActiveMonth(month);
  }, []);

  return (
    <NavigationContext.Provider value={{
      activeMonth, setActiveMonth,
      view, setView,
      section, setSection,
      periodFilter, setPeriodFilter,
      showMonthPicker, setShowMonthPicker,
      navigateTo,
    }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error("useNavigation must be inside NavigationProvider");
  return ctx;
}
